function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("rect", {
  x: 0.815918,
  y: 0.561035,
  width: 9.22,
  height: 9.22,
  fill: "white",
  fillOpacity: 0.38
}), React.createElement("path", {
  d: "M5.37882 0.561035L3.53974 2.40025C3.35659 2.5792 3.39731 2.70538 3.65317 2.70538H4.67957L4.6794 4.94026C4.6794 5.32614 4.99223 5.63931 5.37847 5.63931C5.76453 5.63931 6.07753 5.32631 6.07753 4.94026L6.07771 2.70521H7.10464C7.36015 2.70538 7.40052 2.57886 7.21754 2.3999L5.37882 0.561035Z",
  fill: "#1C355E"
}), React.createElement("path", {
  d: "M9.38422 5.06445H8.32705C8.23023 5.06445 8.15229 5.14257 8.15229 5.23922V8.3743H2.69991V5.23922C2.69991 5.14257 2.62179 5.06445 2.52514 5.06445H1.46798C1.37133 5.06445 1.29321 5.14257 1.29321 5.23922V8.81558C1.29321 9.34774 1.72646 9.78062 2.25862 9.78062H8.59357C9.12591 9.78062 9.55881 9.34739 9.55881 8.81558V5.23922C9.55899 5.14257 9.48104 5.06445 9.38422 5.06445Z",
  fill: "#1C355E"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  x: 0.815918,
  y: 0.561035,
  width: 9.22,
  height: 9.22,
  fill: "white"
})));

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.d1cce247.svg";
export { ForwardRef as ReactComponent };